<template>
	<vs-popup
		:active.sync="showPopup"
		title="Configuration Big Query"
		class="big-query-popup"
	>
		<div class="popup-content">
			<!-- Filter Section -->
			<div class="filter-section mb-4">
				<div class="vx-row">
					<div class="vx-col w-full md:w-1/3">
						<label>Client</label>
						<vs-select
							autocomplete
							v-model="filterSocietyId"
							class="w-full"
							placeholder="Filtrer par client"
							@change="applyFilter"
						>
							<vs-select-item value="" text="Tous" class="w-full" />
							<vs-select-item
								:key="index"
								:value="item.id"
								:text="item.name"
								v-for="(item, index) in allSocieties"
								class="w-full"
							/>
						</vs-select>
					</div>
				</div>
			</div>

			<!-- Table -->
			<vs-table :data="filteredSocieties" max-items="100" pagination>
				<template slot="thead">
					<vs-th>Nom de la société</vs-th>
					<vs-th>Export Big Query</vs-th>
				</template>

				<template slot-scope="{ data }">
					<vs-tr :key="index" v-for="(tr, index) in data">
						<vs-td>{{ tr.name }}</vs-td>
						<vs-td>
							<vs-switch
								v-model="tr.export_to_big_query"
								:vs-value="1"
								vs-icon-on="check"
								vs-icon-off="close"
								@input="updateExportStatus(tr)"
							/>
						</vs-td>
					</vs-tr>
				</template>
			</vs-table>
		</div>
	</vs-popup>
</template>

<script>
import store from "@/store/store";
import Society from "@/entities/Society";

export default {
	name: "BigQueryPopup",
	props: {
		popupActive: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			showPopup: this.$props.popupActive,
			societies: [],
			filterSocietyId: ""
		};
	},
	computed: {
		allSocieties() {
			return store.state.societies;
		},
		apiUrl() {
			return store.state.backendApiUrl;
		},
		filteredSocieties() {
			if (!this.filterSocietyId) {
				return this.societies;
			}
			return this.societies.filter(s => s.id === this.filterSocietyId);
		}
	},
	watch: {
		popupActive(val) {
			this.showPopup = val;
			if (val) {
				this.loadSocieties();
			}
		},
		showPopup(val) {
			if (!val) {
				this.$emit("close-popup");
			}
		}
	},
	methods: {
		applyFilter() {
			// Filter is applied reactively via filteredSocieties computed
		},
		async loadSocieties() {
			await this.$store.dispatch("getAllSocieties");
			this.societies = this.allSocieties.map(society => ({
				...society,
				export_to_big_query: society.export_to_big_query === 1 || society.export_to_big_query === true ? 1 : 0
			}));
		},
		updateExportStatus(societyData) {
			const value = societyData.export_to_big_query ? 1 : 0;
			const societyToUpdate = new Society({
				...societyData,
				export_to_big_query: value
			});

			societyToUpdate.update(societyData.id, (err, result) => {
				if (err) {
					this.$vs.notify({
						title: "Erreur",
						text: "Erreur lors de la mise à jour",
						color: "danger"
					});
					societyData.export_to_big_query = value ? 0 : 1;
				} else {
					this.$vs.notify({
						title: "Succès",
						text: `Export Big Query ${value ? "activé" : "désactivé"} pour ${societyData.name}`,
						color: "success"
					});
					this.$store.dispatch("getAllSocieties");
				}
			});
		}
	}
};
</script>

<style lang="scss">
.big-query-popup {
	.vs-popup {
		width: 700px;
		max-width: 90vw;
	}
	.popup-content {
		max-height: 70vh;
		overflow-y: auto;
	}
	.filter-section {
		padding: 10px 0;
		label {
			display: block;
			margin-bottom: 5px;
			font-weight: 500;
		}
	}
}
</style>
